import { render, staticRenderFns } from "./fxlist.vue?vue&type=template&id=7bac4517&scoped=true&"
import script from "./fxlist.vue?vue&type=script&lang=js&"
export * from "./fxlist.vue?vue&type=script&lang=js&"
import style0 from "./fxlist.vue?vue&type=style&index=0&id=7bac4517&scoped=lang&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bac4517",
  null
  
)

export default component.exports